import { defineStore } from "pinia";
import apiClient from "@/plugins/axios";

export const usePublicationDetailStore = defineStore("publicationDetail", {
  state: () => ({
    publication: null,
    loading: false,
    error: "",
  }),

  actions: {
    /**
     * Obtener detalle de una publicación
     */
    async fetchPublicationDetail(id) {
      this.loading = true;
      this.error = "";
      this.publication = null;

      try {
        const response = await apiClient.get(`/public/publications/${id}`);
        const data = response.data;

        this.publication = {
          id: data.id,
          title: data.title,
          published: data.published,
          summary: data.summary,
          detail: data.detail,
          image_path: data.image_path,
          document_path: data.document_path,
          download_link: data.download_link,
          pages: data.pages,
          size: data.size,
          language: data.language,
        };
      } catch (error) {
        if (error.code === "ERR_NETWORK") {
          this.error =
            "No se pudo conectar al servidor. Por favor, intenta nuevamente más tarde.";
        } else if (error.response?.status === 404) {
          this.error = "La publicación solicitada no fue encontrada.";
        } else {
          this.error =
            error.response?.data?.message ||
            "Error al cargar la publicación. Intente de nuevo más tarde.";
        }
      } finally {
        this.loading = false;
      }
    },
  },
});
